<template>
  <div class="app show-menu" v-if="isMenu(this.$route.path)">
    <div class="app-header" v-if="!$route.meta.navIsShow" id="app-header">
      <div class="a-logo" id="a-logo">
        <img :src="`${companyPicPath}company_systemLogo.png`" alt @click="$router.push({ path:'/'})" />
        <el-dropdown :show-timeout="10" @command="fastRouter" placement="top">
          <div class="fast-router">
            <img src="./assets/images/public/public_expressway.png" alt />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(fast,index) in fastList" :key="index" :command="index">{{$t(fast)}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="a-nav" id="a-nav">
        <el-menu :router="true" :default-active="activeRoute" class="el-menu-demo" mode="horizontal" menu-trigger="hover" :unique-opened="true" :collapse-transition="false" @select="handleSelect">
          <template v-for="route in menuArray">
            <el-menu-item :key="route.path" :index="route.path" v-if="route.children===undefined || route.children.length===0" class="menu-title" v-show="isShowRoute(route)">{{$t(route.meta.i18n)}}</el-menu-item>
            <template v-else-if="route.children.length===1">
              <el-menu-item :key="route.path" :index="route.path+'/'+route.children[0].path" class="menu-title" v-show="isShowRoute(route)">{{$t(route.meta.i18n)}}</el-menu-item>
            </template>
            <template v-else>
              <el-submenu :show-timeout="0" :key="route.path" :index="route.path" class="menu-title" v-show="isShowRoute(route)">
                <template slot="title">{{$t(route.meta.i18n)}}</template>
                <el-menu-item class="main-menu" v-for="routerItem in route.children" :key="routerItem.path" :index="route.path+'/'+routerItem.path" v-show="isAdminUser(route.path+'/'+routerItem.path)">{{$t(routerItem.meta.i18n)}}</el-menu-item>
              </el-submenu>
            </template>
          </template>
          <el-submenu index="1" v-show="moreArray.length!=0">
            <template slot="title">{{$t('app.more')}}</template>
            <template v-for="moreRute in moreArray">
              <el-menu-item class="main-menu menu-title" :key="moreRute.path" :index="moreRute.path" v-if="moreRute.children===undefined || moreRute.children.length===0 || moreRute.isChild == false" v-show="isShowRoute(moreRute)">{{$t(moreRute.meta.i18n)}}</el-menu-item>
              <template v-else>
                <el-submenu :index="moreRute.path" :key="moreRute.path">
                  <template slot="title">
                    <div class="more-mene-title">{{$t(moreRute.meta.i18n)}}</div>
                  </template>
                  <el-menu-item class="main-menu" style="color: orange;" v-for="moreRuteItem in moreRute.children" :key="moreRuteItem.path" :index="moreRute.path+'/'+moreRuteItem.path" v-show="isAdminUser(moreRute.path+'/'+moreRuteItem.path)">{{$t(moreRuteItem.meta.i18n)}}</el-menu-item>
                </el-submenu>
              </template>
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <div class="a-user" id="a-user">
        <!-- <el-switch
          v-model="language"
          active-value="en"
          @change="languageChanged"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-text="$t('basics.en')"
          :inactive-text="$t('basics.zh')"
        ></el-switch>-->

        <el-dropdown @visible-change="(val) => visibleChange = val" @command="languageChanged">
          <span class="el-dropdown-link flex-c-c" style="white-space:nowrap; margin-right: 8px; cursor:pointer;">
            <img v-if="!visibleChange" src="./assets/images/home/language.png" class="icon language" style alt />
            <img v-else src="./assets/images/home/language_sel.png" class="icon language" style alt />
            {{languageList[$cookies.get("language")]}}
            <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="key" v-for="(value, key) in languageList" :key="key">{{value}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div style="margin-right: 16px;" v-show="KOMHIDDEN == 0"> -->
        <div style="margin-right: 16px;">
          <el-popover ref="popover" placement="bottom" :title="$t('app.Percent')" width="300" trigger="hover">
            <div class="download-list">
              <div style="height:200px;">
                <el-table :data="issueList" style="width: 100%" height="100%" :show-header="false">
                  <el-table-column prop="name" :label="$t('app.TerminalName')" width="80" show-overflow-tooltip></el-table-column>
                  <el-table-column :label="$t('app.ReleaseSchedule')">
                    <div slot-scope="scope">
                      <el-progress :percentage="parseInt(scope.row.downloaded)"></el-progress>
                      <span class="ellipsis-1">{{scope.row.fabu_no}}</span>
                    </div>
                  </el-table-column>
                  <el-table-column :label="$t('app.status')" width="80">
                    <span slot-scope="scope">{{scope.row.download_state|status}}</span>
                  </el-table-column>
                </el-table>
              </div>
              <i class="el-icon-s-data data-list" @click="issueListDV=true"></i>
            </div>
          </el-popover>
          <img v-popover:popover class="uploading icon" src="./assets/images/public/public_headerrelease.png" alt />
        </div>
        <div class="a-user">
          <el-dropdown @command="turnTo">
            <div class="flex-b-c ellipsis-1" @click="goToPerson">
              <img src="./assets/images/user_icon.jpg" alt />
              <span>{{$cookies.get("realname") || $cookies.get("username")}}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="person">{{$t('app.PersonalCenter')}}</el-dropdown-item>
              <el-dropdown-item command="help" v-if="this.$cookies.get('showHelp') == '1'">{{$t('app.HelpDocument')}}</el-dropdown-item>
              <el-dropdown-item command="logout">{{$t('app.LogOut')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="app-body">
      <!-- 检测是否需要进行缓存页面 -->
      <router-view v-if="!$route.meta.isKeep"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.isKeep"></router-view>
      </keep-alive>
    </div>
    <form-dialog :dialogVisible="issueListDV" @closeDialog="issueListCD" dWidth="600px" :title="$t('app.Percent')">
      <uploading-list :issueList="issueList" @getIssueList="getIssueList"></uploading-list>
    </form-dialog>
  </div>
  <div v-else class="app">
    <!-- 检测是否需要进行缓存页面 -->
    <router-view v-if="!$route.meta.isKeep" :key="$route.fullPath"></router-view>
    <keep-alive>
      <router-view v-if="$route.meta.isKeep"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { openSuccessInit } from "./assets/scripts/webSocket"
import superClone from '@/assets/scripts/superClone.js';
import FormDialog from '@/components/basics/FormDialog'
import UploadingList from '@/components/basics/UploadingList'
const fastList = ["app.AddMaterial", "app.CreateProgram", "app.CreateRelease", "app.AddTerminal", "app.CreateAccount"];

import languageList from '@/i18n/languageList.js'

const WSbase = process.env.NODE_ENV === 'production' ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.hostname}:7200` : process.env.VUE_APP_WS;
const baseWS = WSbase + "?from=web";

const base = process.env.NODE_ENV === 'production' ? "" : process.env.VUE_APP_IMG;
const companyPicPath = base + "/company/images/";

// const languageList = {
//   'zh': '简体中文',
//   'en': 'English',
//   'vi': 'Vietnamese'
// }
export default {
  name: 'app',
  data() {
    return {
      navShow: false,
      routes: [],
      activeRoute: "/home",
      companyPicPath: companyPicPath,
      currentRoleRoute: [], //当前角色所能显示的路由
      issueList: [],
      deviceList: [],
      count: 0,
      DeviceTime: 480000,
      menuArray: [],
      moreArray: [],
      issueListDV: false,
      KOMHIDDEN: 0,
      menuWidth: 0,
      fastList,
      language: "",
      visibleChange: false,
      languageList
    }
  },
  created() {
    this.$http.post("/admin/access/getSystemLayout", {}, res => {
      res.forEach((layout) => {
        const { key, value } = layout;
        this.$cookies.set(key, value);
      });
      document.title = this.$cookies.get('webTitle');
    });
    // 获取所有路由选项过滤出需要在菜单显示的路由,hidden为true的时候不需要显示
    this.KOMHIDDEN = parseInt(process.env.VUE_APP_KOM_HIDDEN);
    this.routes = this.routesFilter(this.$router.options.routes);
    this.getCurrentRoleRoute();
    //console.log(this.routes)
    // console.log(this.routes);
    // 获取当前开发状态
    // console.log(process.env);
    this.$cookies.get('isLogin') && this.createWebSocketConnection();
    this.$cookies.get('isLogin') && this.getIssueList();
    // setTimeout(() => {
    // 	this.$cookies.get('isLogin') && this.sendToUser();
    // }, 1000)
    //this.menuOrSelect();
    if (this.$cookies.get("language")) {
      this.$i18n.locale = this.$cookies.get("language");
    } else {
      this.getLanguage();
    }
  },
  mounted() {

    this.menuOrSelect();

    window.onresize = () => {
      if (document.getElementById('a-nav') != null) {
        this.menuOrSelect()
      }
    }

    // ******下载进度START******
    if (!this.myWebSocket) {
      return;
    }

    this.myWebSocket.addEventListener("message", (value) => {
      this.statusUpdates(value);
      // console.log(value);
    });

    //this.enlishTitle();
    // 备用方法
    this.myWebSocket.onmessage = (value) => {
      // console.log(value);
      this.statusUpdates(value);
    };
    // ******下载进度END******
    //let then = this;
  },
  filters: {
    // ******下载进度START******
    // 0-等待1-下载中2-下载失败3-下载成功4-断电失效5-设备离线6-取消
    status(key) {
      switch (`${key}`) {
        case "0":
          return "等待中";
        case "1":
          return "下载中";
        case "2":
          return "下载失败";
        case "3":
          return "下载成功";
        case "4":
          return "重连失效";
        case "5":
          return "设备离线";
        case "6":
          return "已取消";
        default:
          return "无状态";
      }
    }
    // ******下载进度END******
  },
  methods: {
    languageChanged(key) {
      this.$i18n.locale = key;
      this.$cookies.set("language", this.$i18n.locale);
      this.menuOrSelect()
    },
    getLanguage() {
      let language = (navigator.language || navigator.browserLanguage).toLowerCase();
      if (language.indexOf('zh') != -1) {
        // 浏览器语言是中文
        this.languageChanged('zh');
        console.log("浏览器语言是中文" + this.$i18n.locale);
      } else if (language.indexOf('en') != -1) {
        // 浏览器语言是英文
        this.languageChanged('en');
        console.log("浏览器语言是英文" + this.$i18n.locale);
      } else {
        // 浏览器语言是其它
        this.languageChanged('en');
        console.log("浏览器语言是其它");
      }
    },
    // 快捷操作
    fastRouter(type) {
      switch (type) {
        case 0: {
          // console.log(type);
          this.$router.push({
            path: "/explorer/newMediaList"
          });
        }
          break;
        case 1: {
          // console.log(type);
          this.$router.push({
            name: "ProgramManage",
            params: {
              type: 'addProgram'
            }
          });
        }
          break;
        case 2: {
          // console.log(type);
          this.$router.push({
            path: "/schedule/issueManage"
          });
        }
          break;
        case 3: {
          // console.log(type);
          this.$router.push({
            name: "Control",
            params: {
              type: 'addTerminal'
            }
          });
        }
          break;
        case 4: {
          // console.log(type);
          this.$router.push({
            name: "UserManage",
            params: {
              type: 'addUser'
            }
          });
        }
          break;
        default:
          break;
      }
    },
    statusUpdates(value) {
      // 获取下载进度信息
      let info = JSON.parse(value.data);
      // 当返回停止下载立即重置状态
      if (info.type === 'stop_download') {
        let index = this.issueList.findIndex(item => item.dc_id === info.data.dc_id);
        this.issueList[index].download_state = "6";
        return;
      }
      // 根据获取的状态查找当前列表中的设备
      let index = this.issueList.findIndex(item => item.dc_id === info.dc_id);
      // 当检测到设备状态为6时不接后后面的状态，除非重传启动f
      if (index > -1 && this.issueList[index].download_state == "6") {
        return;
      }
      // 根据状态码更新下载进度
      if (index > -1) {
        let data = info.data;
        switch (data.status) {
          case 1:
            if (data.params.downloaded >= 100) {
              this.issueList[index].download_state = "3";
              break;
            }
            this.issueList[index].downloaded = data.params.downloaded;
            this.issueList[index].download_state = "1";
            break;
          case 2:
            this.issueList[index].download_state = "2";
            break;
          case 3:
            this.issueList[index].downloaded = 100;
            this.issueList[index].download_state = "3";
            break;
          case 4:
            this.issueList[index].downloaded = data.params.downloaded;
            this.issueList[index].download_state = "4";
            break;
          case 5:
            this.issueList[index].download_state = "5";
            break;
          default:
            break;
        }
      }
    },
    isAdminUser(route) {
      if (this.$cookies.get('isadmin') == 0 && route === '/system/roleManage') {
        return false;
      }
      if (this.$cookies.get('isadmin') == 0 && route === '/system/systemLayout') {
        return false;
      }
      if (this.$cookies.get('isadmin') == 0 && route === '/system/templateManagement') {
        return false;
      }
      return true;
    },
    isShowRoute(route) {
      // console.log(route.path);
      let role = parseInt(this.$cookies.get('role_id'));
      if (role == 1) {
        return true;
      }
      if (role == 2) {
        switch (route.path) {
          case '/review':
            return false;
          default:
            return true;
        }
      }
      if (role == 3) {
        switch (route.path) {
          case '/review':
            return true;
          default:
            return false;
        }
      }
      return true;
      // /explorer
      // /schedule
      // /review
      // /system
      // /log
      // /terminal
      // /explorer
      // /schedule
      // /review
      // /system
      // /log
      // /terminal
    },
    getCurrentRoleRoute() {
      let role = parseInt(this.$cookies.get('role_id'));
      this.currentRoleRoute = [];
      switch (role) {
        case 3:
          this.routes.forEach(ele => {
            if (ele.path === '/review') {
              this.currentRoleRoute.push(ele)
            }
          })
          break;
        case 2:
          this.routes.forEach(ele => {
            if (ele.path !== '/review') {
              this.currentRoleRoute.push(ele)
            }
          })
          break;
        case 1:
          this.currentRoleRoute = this.routes;
          break
        default:
          this.currentRoleRoute = this.routes;
      }

    },
    menuOrSelect() {
      //let appHeader = document.getElementById('app-header').offsetWidth - 44; //顶部导航栏宽度，去除44的padding
      //let leftLogoWidth = document.getElementById('a-logo').offsetWidth;
      //let rightUser = document.getElementById('a-user').offsetWidth;

      //console.log(document.getElementsByClassName('app-header')[0].style.width)
      //this.menuWidth = appHeader - leftLogoWidth - rightUser - 8 - 132 - 10; //得到导航栏总体的宽度
      //console.log(this.menuWidth)

      // this.menuWidth = document.getElementById('a-nav').offsetWidth - 132 - 8;
      // //console.log('当前角色的权限',this.currentRoleRoute)
      // this.currentRoleRoute.forEach(ele => {
      // 	ele.width = ele.meta.title.length * 18 + (ele.children.length >= 2 ? 20 : 0) +
      // 		40; //20是小三角的 40是padding
      // })
      // //console.log(this.menuWidth)
      // let widthTotal = 0;
      // let menuNumber = 0;
      // let flag = false;
      // for (let i = 0; i < this.currentRoleRoute.length; i++) {
      // 	widthTotal += this.currentRoleRoute[i].width;
      // 	if (widthTotal > this.menuWidth) {
      // 		menuNumber = i;
      // 		flag = true;
      // 		break;
      // 	}
      // }
      // if (flag === false) {
      // 	menuNumber = this.currentRoleRoute.length;
      // }
      // this.menuArray = [];
      // this.moreArray = [];

      // for (let i = 0; i < menuNumber; i++) {
      // 	this.menuArray.push(this.currentRoleRoute[i])
      // }
      // for (let i = menuNumber; i < this.currentRoleRoute.length; i++) {
      // 	this.moreArray.push(this.currentRoleRoute[i])
      // }
      this.menuArray = this.currentRoleRoute;
      this.moreArray = [];
      this.$nextTick(() => {
        let tit = document.getElementsByClassName('menu-title');
        let menuW = document.getElementById('a-nav');
        let widthT = 0;
        let flag = null;
        for (let i = 0; i < tit.length; i++) {
          widthT += tit[i].offsetWidth;
          if (widthT > menuW.offsetWidth - 8) {
            flag = i - 1;
            break;
          }
        }
        this.menuArray = [];
        this.moreArray = [];
        (flag == null) && (flag = this.currentRoleRoute.length);
        for (let i = 0; i < flag; i++) {
          this.menuArray.push(this.currentRoleRoute[i])
        }
        for (let i = flag; i < this.currentRoleRoute.length; i++) {
          this.moreArray.push(this.currentRoleRoute[i])
        }
        //flag!=null && console.log('只能放到第',flag,'个',tit[flag-1].innerText)
        //console.log('tit',tit)
        //console.log('总宽',widthT)
      })
    },
    enlishTitle() {

    },
    // ******下载进度START******
    getIssueList() {
      this.$http.post("/admin/Command/getDownloadList", {}, data => {
        this.$store.commit("ISSUE_LIST", data);
      });
    },
    issueListCD() {
      this.issueListDV = false;
    },
    // ******下载进度END******
    isMenu(val) {
      // console.log(val);
      switch (val.toLowerCase()) {
        case '/login'.toLowerCase():
          return false;
        case '/schedule/windowsIndex'.toLowerCase():
          return false;
        case '/system/ReferralCode'.toLowerCase():
          return false;
        case '/help'.toLowerCase():
          return false;
        default:
          return true;
      }
    },
    // 获取所有路由选项过滤出需要在菜单显示的路由,hidden为true的时候不需要显示
    // 递归出所有满足条件的路由
    routesFilter(route) {
      return route.filter(router => {
        if (router.children !== undefined) {
          router.children = this.routesFilter(router.children);
        }
        return router.hidden === false || router.hidden === undefined;
      });
    },
    // eslint-disable-next-line no-unused-vars
    handleSelect(key, keyPath) {
      // 打印路由切换目标
      // console.log(key, keyPath);
    },
    createWebSocketConnection() {
      let ws = new WebSocket(baseWS);
      this.$store.commit("MY_WEBSOCKET", ws);
      this.$store.getters.timerMyWebSocketTimeInter && clearTimeout(this.$store.getters.timerMyWebSocketTimeInter);
      let timerMyWebSocketTimeOut = setTimeout(() => {
        ws.close();
        this.$msg({
          message: "WebSocket连接超时",
          type: "warning",
          showClose: true
        });
      }, 10000);
      this.$store.commit("TIMER_MYWEBSOCKET_TIMEOUT", timerMyWebSocketTimeOut);
      // eslint-disable-next-line no-unused-vars
      ws.onopen = ev => {
        openSuccessInit(this);
      };
      // eslint-disable-next-line no-unused-vars
      ws.onclose = ev => {
        this.$msg({
          message: "WebSocket连接断开",
          type: "warning",
          showClose: true
        });
        clearInterval(this.$store.getters.timerMyWebSocketTimeOut);
        let timerMyWebSocketTimeInter = setTimeout(() => {
          this.createWebSocketConnection();
        }, 10000);
        this.$store.commit("TIMER_MYWEBSOCKET_TIMEINTER", timerMyWebSocketTimeInter);
      };
      // eslint-disable-next-line no-unused-vars
      ws.onerror = ev => { }
    },
    goToPerson() {
      this.$router.push({
        name: "PersonalCenter"
      });
    },
    turnTo(command) {
      switch (command) {
        case 'person': {
          this.$router.push({
            name: "PersonalCenter"
          });
        }
          break;
        case 'help': {
          // this.$router.push({
          //   name: "Help"
          // });
          window.open("http://admin.kystarcloud.com/help");
        }
          break;
        case 'logout': {
          this.$cookies.keys().forEach(key => {
            if (!(key === 'rtp' || key === 'language')) {
              this.$cookies.remove(key);
            }
          })
          this.$router.push({
            path: "/login"
          });
        }
          break;
      }
    },
    async deviceRunState() {
      let forNumber = 0;
      this.deviceList = [];
      await this.$http.post('/admin/device/list', {
        page: 1,
        group_ids: this.$cookies.get('group_ids'),
        limit: 50
      }, data => {
        this.count = data.count ? data.count : 0;
        this.deviceList = data.list ? data.list : [];
      })
      forNumber = parseInt(this.count / 50) + 1;
      for (let i = 2; i <= forNumber; i++) {
        this.$http.post('/admin/device/list', {
          page: i,
          group_ids: this.$cookies.get('group_ids'),
          limit: 50
        }, data => {
          //count = data.count ? data.count : 0;
          this.deviceList = data.list ? this.deviceList.concat(data.list) : [];
        })
      }
    },
    async sendToUser() {
      let oldDeviceList = [];
      await this.deviceRunState();
      let inte = setInterval(() => {
        if (this.count == this.deviceList.length) {
          oldDeviceList = this.deviceList;
          clearInterval(inte)
        }
        if (!this.$cookies.get('isLogin')) {
          clearInterval(inte)
        }
      })
      let globle = setInterval(() => {
        this.deviceRunState();
        let inte = setInterval(() => {
          if (this.count == this.deviceList.length) {
            oldDeviceList.forEach(ele => {
              this.deviceList.forEach(val => {
                if (ele.id == val.id) {
                  if (ele.run_state !== val.run_state) {
                    if (val.run_state == 0) {
                      this.$notify({
                        title: "离线通知",
                        message: `您的设备${val.name}离线了`,
                        type: 'warning',
                        duration: 0
                      });
                      console.log(`您的设备${val.name}离线了`);
                    } else if (val.run_state > 0) {
                      this.$notify({
                        title: "上线通知",
                        message: `您的设备${val.name}上线了`,
                        type: 'success',
                        duration: 0
                      });
                      console.log(`您的设备${val.name}上线了`);
                    }
                    ele.run_state = val.run_state;
                  }
                }
              })
            })
            clearInterval(inte)
          }
        })
        if (!this.$cookies.get('isLogin')) {
          clearInterval(globle)
        }
      }, this.DeviceTime)
    }
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
    getIssueHistory() {
      return this.$store.state.websocket.issueList;
    }
  },
  watch: {
    getIssueHistory: {
      handler(newList) {
        this.issueList = superClone(newList).sort((a, b) => new Date(b.create_time).getTime() - new Date(a.create_time).getTime());
        this.issueList.forEach((program) => {
          if (program.download_state == 3) {
            program.downloaded = 100;
          }
        });

      }
    }
  },
  components: {
    FormDialog,
    UploadingList
  }
}
</script>

<style lang="scss" scoped>
.show-menu {
  min-width: 1024px;
}

.app {
  width: 100%;
  height: 100%;
  // 页面最小尺寸
  // min-width: 1024px;
  display: flex;
  flex-direction: column;

  .app-header {
    height: 64px;
    padding: 0px 22px;
    background-image: linear-gradient(
        270deg,
        #86eae7 0%,
        #4cccf0 50%,
        #11adf8 100%
      ),
      linear-gradient(#dddddd, #dddddd);
    background-blend-mode: normal, normal;
    display: flex;
    justify-content: flex-start;

    .a-logo {
      width: 240px;
      height: 100%;
      // background-color: rgba($color: #fff, $alpha: 0.9);
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 200px;
        height: 40px;
        margin-right: 20px;
      }

      .fast-router {
        width: 30px;
        height: 30px;
        padding: 2px;
        border-radius: 50%;
        background-color: #fff;
        cursor: pointer;

        &:hover {
          background-color: rgba($color: #fff, $alpha: 0.5);
        }

        img {
          width: 30px;
          height: 30px;
        }
      }
    }

    .a-nav {
      padding-left: 8px;
      width: calc(100% - 240px - 154px);

      .el-menu {
        background: none;
        border: none;
      }

      .el-menu-item,
      /deep/ .el-submenu__title {
        font-size: 18px;
        color: #fff;
        height: 64px;
        line-height: 64px;
      }

      .menu-title.is-active {
        background: none;
        background-color: rgba($color: #fff, $alpha: 0.3);
      }

      .menu-title.is-opened > .el-submenu__title {
        background: none;
        background-color: rgba($color: #fff, $alpha: 0.3) !important;
      }

      .menu-title:hover {
        background-color: rgba($color: #fff, $alpha: 0.2);
      }

      /deep/ .el-submenu__title:hover {
        background: none;
      }
    }

    .a-user {
      // width: 154px;
      width: 240px;
      display: flex;
      margin-left: auto;
      justify-content: center;
      align-items: center;

      .language {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      .uploading {
        width: 35px;
        height: 30px;
        margin-top: 4px;
        border-radius: 0;
      }

      img {
        width: 36px;
        height: 36px;
        border-radius: 25px;
        cursor: pointer;
      }

      span {
        padding-left: 8px;
        color: #ffffff;
      }
    }
  }

  .app-body {
    height: calc(100% - 64px);
    background-color: #edfbff;
  }
}

.form-dialog {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;

  .d-list {
    overflow: auto;
    height: calc(100% - 40px);
  }

  .d-btn {
    height: 40px;
    display: flex;
    justify-content: center;

    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}

.download-list {
  height: 200px;
  position: relative;

  .data-list {
    font-size: 32px;
    position: absolute;
    bottom: 0;
    left: 0;
    cursor: pointer;
  }
}
</style>
